import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import alertMessage from '../utils/alertMessage'
import apiManagementAPI from '../apis/apiManagementAPI'
import {toJS} from 'mobx'

export default class ApiManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  /*change directionType*/
  @observable directionType = 'Outbound'

  @action
  onChangeDirectionType(value) {
    this.directionType = value
    this.itemCount = 0
    this.pageNo = 1
    this.pageSize = PAGE_SIZE_DEFAULT
  }

  /*SearchResult start*/
  @observable searchItem = {
    apiName: '',
    status: null,
    outboundType: '',
  }
  @observable apiList = []
  @observable scheduledConfigInfo = {}
  @observable apiNames = []
  @observable apiPartys = []
  @observable selectedRows = []
  @observable tableName = []
  @observable sqlData = {}

  @action
  async onLoadDefaultPage() {
    this.isFetching = true
    this.apiList = []
    this.itemCount = 0
    this.pageNo = 1
    this.searchItem = {
      apiName: '',
      status: null,
      outboundType: '',
    }
    try {
      const response = await apiManagementAPI.searchAction(this.searchItem, 1, PAGE_SIZE_DEFAULT)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 200) {
          this.apiList = response.data.data.content || []
          this.itemCount = response.data.data.totalElements
          let apiPartySet = new Set()
          this.apiList.map(item => {
            return apiPartySet.add(item.type)
          })
          this.apiPartys = [...apiPartySet]
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSearchApiAction(params, pageNo, pageSize) {
    this.isFetching = true
    this.apiList = []
    this.apiNames = []
    this.pageNo = pageNo
    if (pageSize) {
      this.pageSize = pageSize
    }
    this.itemCount = 0
    try {
      const response = await apiManagementAPI.searchAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.apiList = response.data.data.records || []
          this.itemCount = response.data.data.total
          this.searchItem = params
          this.pageNo = pageNo
          this.apiNames = response.data.data?.records.sort(function (a, b) {
            return a.apiName.toLowerCase().localeCompare(b.apiName.toLowerCase())
          })
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async delAction(id) {
    this.isFetching = true
    try {
      const response = await apiManagementAPI.delResultAction(id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchApiAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Delete Failed！')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSearchApiNamesAction() {
    this.isFetching = true
    this.apiNames = []
    try {
      const response = await apiManagementAPI.searchApiNames()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 200) {
          this.apiNames = response.data.data || []
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSearchScheduleAction(id) {
    this.isFetching = true
    this.scheduledConfigInfo = {}
    try {
      const response = await apiManagementAPI.searchScheduleAction(id)
      console.log(response)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.scheduledConfigInfo = response.data.data.scheduledConfigInfo || {}
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onScheduleApiAction(id, params, enable) {
    this.isFetching = true
    try {
      params.enable = enable
      const response = await apiManagementAPI.scheduleAction(id, params)
      runInAction(() => {
        if (response.data.code === 0) {
          // this.onScheduleEnableAction(id,enable)
          alertMessage.success('Edit Success！')
          this.onSearchApiAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Edit Failed！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*schedule status*/
  @action
  async onScheduleEnableAction(id, enable) {
    this.isFetching = true
    try {
      const response = await apiManagementAPI.scheduleEnableAction(id, enable)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 200) {
          alertMessage.success('Edit Success！')
          this.onSearchApiAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Failed！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*outbound status*/
  @action
  async onChangeStatus(apiID, param) {
    this.isFetching = true
    try {
      const response = await apiManagementAPI.statusAction(apiID, param)
      runInAction(() => {
        this.isFetching = false
        // if (response.data.code === 200) {
        if (response.data.code === 0) {
          alertMessage.success('Success！')
          this.onSearchApiAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Failed！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*inbound list*/
  @observable searchItemInbound = {
    name: '',
    status: null,
    inboundType: '',
  }

  @action
  // async onSearchInboundAction(searchItem, pageNo, pageSize) {
  //   this.isFetching = true
  //   this.apiList = []
  //   this.pageNo = pageNo;
  //   this.pageSize = pageSize;
  //   this.itemCount = 0
  //   try {
  //     this.apiList = []
  //     this.searchItemInbound = searchItem
  //     const response = await apiManagementAPI.searchInboundAction(searchItem, pageNo ? pageNo-1 : 0, pageSize)
  //     runInAction(() => {
  //       this.isFetching = false;
  //       if(response.data.data===null){
  //         alertMessage.error('Failed！ Data Platfrom no data!')
  //       }else{
  //         this.apiList = response.data.data?.content || []
  //         this.itemCount = response.data.data?.totalElements
  //       }
  //     })
  //   } catch (err) {
  //     alertMessage.error(err.message)
  //     runInAction(() => {
  //       this.isFetching = false;
  //     });
  //   }
  // }
  /*inbound active*/
  @action
  async onChangeInboundStatus(apiID, param) {
    this.isFetching = true
    try {
      const response = await apiManagementAPI.inboundStatusAction(apiID, param)
      runInAction(() => {
        this.isFetching = false
        // if (response.data.code === 200) {
        if (response.data.code === 0) {
          alertMessage.success('Success！')
          this.onSearchInboundAction(this.searchItemInbound, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Failed！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*ping*/
  @action
  async onPingAction(id) {
    this.isFetching = true
    try {
      const response = await apiManagementAPI.pingAction(id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 200) {
          if (response.data.data) {
            alertMessage.success('Success！')
          } else {
            alertMessage.error('Failed！')
          }
        } else {
          alertMessage.error('Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchApiAction(this.searchItem, pageNo, pageSize)
    // if(this.directionType==='OUTBOUND'){
    //   this.onSearchApiAction(this.searchItem, pageNo, pageSize)
    // }else {
    //   this.onSearchInboundAction(this.searchItemInbound, pageNo, pageSize)
    // }
  }

  /*ping*/
  @action
  async runTask(record) {
    let arr = toJS(this.apiList)
    let index
    arr.map((item, i) => {
      if (record.id === item.id) {
        item['isLoading'] = true
        index = i
      }
      return arr
    })
    this.apiList = arr
    try {
      await apiManagementAPI.runTask({id: record.id})
      runInAction(() => {
        alertMessage.success('Success！')
        this.apiList[index].isLoading = false
      })
    } catch (err) {
      alertMessage.error(err.message)
      this.apiList[index].isLoading = false
    }
  }

  @action
  generateSql = async params => {
    try {
      const response = await apiManagementAPI.generateSql(params)
      const {data} = response.data
      runInAction(() => {
        this.sqlData = data
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
    }
  }

  @action
  saveSelectedRows(value) {
    this.selectedRows = value
  }

  @action
  saveTableName(value) {
    this.tableName = [value]
  }
}
